// 32問・8特性（各特性4問）。
// 各質問は自分の effect 特性のみに加点し、反対特性への加点は行わない。
// memorii アプリ本体（lib/9.type/personality.dart）の質問セットを移植。
export type PersonalityEffect = 'H' | 'C' | 'S' | 'R' | 'T' | 'E' | 'J' | 'P';

export type PersonalityQuestion = {
  number: number;
  question: string;
  effect: PersonalityEffect;
};

export const questionList: PersonalityQuestion[] = [
  // H: 専門性・完成度志向
  { number: 1, question: '細かい部分を整えて、完成度を上げていく作業は楽しい。', effect: 'H' },
  { number: 2, question: '一度できるようになったことでも、もっと上手くできる方法を探したくなる。', effect: 'H' },
  { number: 3, question: '周りから見れば十分でも、自分が気になる部分があると直したくなる。', effect: 'H' },
  { number: 4, question: '一つの技術を深く練習して、上達していくことに達成感を感じる。', effect: 'H' },
  // C: 関係性・顧客志向
  { number: 5, question: '人から相談されることは嬉しい。', effect: 'C' },
  { number: 6, question: '相手の表情や話し方の変化に気づくことが多い。', effect: 'C' },
  { number: 7, question: '一度関わった人とは、その後も良い関係を続けたいと思う。', effect: 'C' },
  { number: 8, question: '人と話したあと、その人がどんな気持ちだったかを振り返ることがある。', effect: 'C' },
  // T: サポート成長志向
  { number: 9, question: '初めてのことは、やり方を説明してもらってから始める方が安心する。', effect: 'T' },
  { number: 10, question: '途中でこまめにアドバイスをもらえると、取り組みやすい。', effect: 'T' },
  { number: 11, question: '基本となる見本や正解がある方が、覚えやすい。', effect: 'T' },
  { number: 12, question: '段階ごとに目標が決まっている方が、成長しやすいと感じる。', effect: 'T' },
  // E: 自律成長志向
  { number: 13, question: '分からないことがあると、まず自分で調べたり試したりすることが多い。', effect: 'E' },
  { number: 14, question: 'やり方を細かく決められるより、自分で工夫できる方がやる気が出る。', effect: 'E' },
  { number: 15, question: 'まず自分なりにやってから、必要なところだけアドバイスをもらいたい。', effect: 'E' },
  { number: 16, question: '目標は、人に決めてもらうより自分で決めた方が動きやすい。', effect: 'E' },
  // S: 安定・着実志向
  { number: 17, question: '慣れているやり方で安定してできると安心する。', effect: 'S' },
  { number: 18, question: '新しいことに進む前に、今やっていることをしっかり身につけたい。', effect: 'S' },
  { number: 19, question: '毎日の流れがある程度決まっている方が落ち着く。', effect: 'S' },
  { number: 20, question: '一度気に入ったやり方は、頻繁に変えなくても気にならない。', effect: 'S' },
  // R: 挑戦・変化志向
  { number: 21, question: '今までやったことのないことを試すのは楽しい。', effect: 'R' },
  { number: 22, question: '新しいやり方を知ると、自分でも試してみたくなる。', effect: 'R' },
  { number: 23, question: '同じことが続くと、何か変化を加えたくなる。', effect: 'R' },
  { number: 24, question: '髪型やファッションでは、見慣れたものより新しい表現に惹かれることが多い。', effect: 'R' },
  // J: 計画・構造志向
  { number: 25, question: '予定を事前に決めておくと安心する。', effect: 'J' },
  { number: 26, question: 'やることがいくつかあると、先に順番を決めたくなる。', effect: 'J' },
  { number: 27, question: '長めの課題は、途中の区切りを決めて進めることが多い。', effect: 'J' },
  { number: 28, question: '何かを作るとき、完成形をある程度イメージしてから始めることが多い。', effect: 'J' },
  // P: 柔軟・適応志向
  { number: 29, question: 'その日の状況に合わせて予定を変えることは、あまり苦にならない。', effect: 'P' },
  { number: 30, question: '最初に細かく決めるより、始めてから考える方がやりやすい。', effect: 'P' },
  { number: 31, question: '予定のない休日は、その日の気分でやることを決めたい。', effect: 'P' },
  { number: 32, question: 'やることが複数あるとき、その時取り組みやすいものから進めることが多い。', effect: 'P' },
];

export const pageTitles = [
  '将来の美容師像を診断してみよう！',
  '周りからどんな人って言われる？',
  'どんな動物って診断されて欲しい？',
  'これで最後！あと、少し！',
];
